/**
 * 图片URL处理工具
 * 根据环境自动构建正确的图片URL
 */

/**
 * 获取完整的图片URL
 * @param {string} path - 图片路径
 * @returns {string} 完整的图片URL
 */
export function getFullImageUrl(path) {
    if (!path) return ''
    if (path.startsWith('http')) return path

    // 开发环境和生产环境的图片URL处理
    if (process.env.NODE_ENV === 'development') {
        // 开发环境：指向本地后端服务器
        return `http://localhost:3000${path.startsWith('/') ? path : '/' + path}`
    } else {
        // 生产环境：使用相对路径，通过nginx代理
        return path.startsWith('/') ? path : '/' + path
    }
}

/**
 * 批量处理图片URL
 * @param {Array} images - 图片路径数组
 * @returns {Array} 完整的图片URL数组
 */
export function getBatchImageUrls(images) {
    if (!Array.isArray(images)) return []
    return images.map(img => getFullImageUrl(img))
}

/**
 * 获取上传目录的完整URL
 * @param {string} category - 上传分类 (avatar, product, banner等)
 * @param {string} filename - 文件名
 * @returns {string} 完整的图片URL
 */
export function getUploadImageUrl(category, filename) {
    if (!category || !filename) return ''
    const path = `/uploads/${category}/${filename}`
    return getFullImageUrl(path)
}
